import React from "react";
import { Typography, Tooltip, MenuItem } from "@material-ui/core";
import ProfileImg from "@icarius-common/profileImg";
import { useSelector } from "react-redux";
import { getAppColor, getUserData } from "@icarius-app/selectors";
import DotsMenu from "@icarius-common/dotsMenu";
import { getLocalizedString } from "@icarius-localization/strings";

const UserSection = (props) => {
    const {
        employees,
        handleSelect,
        handleViewCollaborator,
        handleAddCollaborator,
        handleDeleteCollaborator,
        handleChangeCollaboratorStatus,
    } = props;

    const color = useSelector(getAppColor);
    const { level } = useSelector(getUserData);

    return (
        <div style={{ width: "100%", overflow: "auto", paddingBottom: 5 }}>
            <div style={{ display: "flex", gap: 25, marginTop: 10 }}>
                {employees.map((item) => {
                    return (
                        <div key={item.key} style={{ display: "flex", gap: 10 }}>
                            <ProfileImg image={item.image} size={40} />
                            <div style={{ display: "flex", gap: 5 }}>
                                <Tooltip title={item.name}>
                                    <div onClick={() => handleSelect(item.key)} style={{ cursor: "pointer" }}>
                                        <Typography
                                            style={{
                                                fontSize: 16,
                                                fontWeight: item.isChecked ? 600 : 100,
                                                color: item.isChecked ? color : "var(--mainText)",
                                            }}
                                            noWrap
                                        >
                                            {item.name}
                                        </Typography>
                                        <Typography className="whiteText" style={{ fontSize: 14 }}>
                                            {item.statusName}
                                        </Typography>
                                    </div>
                                </Tooltip>
                                {["M", "E"].includes(level) && (
                                    <DotsMenu>
                                        <MenuItem onClick={() => handleViewCollaborator(item)}>
                                            {getLocalizedString("seeEmployeeData")}
                                        </MenuItem>
                                        {level === "E" && ["P"].includes(item.status) && (
                                            <MenuItem onClick={() => handleAddCollaborator(item.key)}>
                                                {getLocalizedString("assignToProcessControl")}
                                            </MenuItem>
                                        )}
                                        {level === "E" && ["C", "D"].includes(item.status) && (
                                            <MenuItem onClick={() => handleChangeCollaboratorStatus(item.key, "P")}>
                                                {getLocalizedString("removeFromProcessControl")}
                                            </MenuItem>
                                        )}
                                        {level === "E" && ["C"].includes(item.status) && (
                                            <MenuItem onClick={() => handleChangeCollaboratorStatus(item.key, "D")}>
                                                {getLocalizedString("stopProcessControl")}
                                            </MenuItem>
                                        )}
                                        {level === "E" && ["D"].includes(item.status) && (
                                            <MenuItem onClick={() => handleChangeCollaboratorStatus(item.key, "C")}>
                                                {getLocalizedString("reassignProcessControl")}
                                            </MenuItem>
                                        )}
                                        {level === "E" && ["C"].includes(item.status) && (
                                            <MenuItem onClick={() => handleChangeCollaboratorStatus(item.key, "R")}>
                                                {getLocalizedString("moveToDone")}
                                            </MenuItem>
                                        )}
                                        {level === "E" && ["P", "C", "D"].includes(item.status) && (
                                            <MenuItem onClick={() => handleDeleteCollaborator(item.key)}>
                                                {getLocalizedString("removeProcessCompletely")}
                                            </MenuItem>
                                        )}
                                    </DotsMenu>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default UserSection;
